import {
	DriftClient,
	DriftClientConfig,
	DriftClientSubscriptionConfig,
	DriftEnv,
	DelistedMarketSetting,
	Wallet,
	BulkAccountLoader,
	DRIFT_PROGRAM_ID,
	WebSocketDriftClientAccountSubscriberV2,
} from '@drift-labs/sdk';
import { Connection, PublicKey } from '@solana/web3.js';
import { UIMarket } from '@drift/common';
import Env, {
	SubscriberType,
} from 'src/environmentVariables/EnvironmentVariables';
import { DRIFT_CLIENT_OPTS } from 'src/stores/DriftStore/constants';

export const generateDriftClient = (
	connection: Connection,
	accountLoader: BulkAccountLoader,
	wallet: Wallet,
	env: DriftEnv,
	subscriberType?: SubscriberType
) => {
	// TEMP: disabled websocket sub while we investigate memory/leaking connections issues
	const wsAccountSubscription: DriftClientSubscriptionConfig = {
		type: 'websocket',
		driftClientAccountSubscriber: WebSocketDriftClientAccountSubscriberV2,
		logResubMessages: false,
		resubTimeoutMs: 30_000,
	};

	const accountSubscription: DriftClientSubscriptionConfig =
		subscriberType === 'websocket'
			? wsAccountSubscription
			: {
					type: 'polling',
					accountLoader: accountLoader,
				};

	const driftClientConfig: DriftClientConfig = {
		connection: connection,
		wallet,
		programID: new PublicKey(DRIFT_PROGRAM_ID),
		accountSubscription,
		perpMarketIndexes: UIMarket.perpMarkets.map((m) => m.marketIndex),
		spotMarketIndexes: UIMarket.spotMarkets.map((m) => m.marketIndex),
		oracleInfos: Env.oracleInfos,
		userStats: true,
		includeDelegates: true,
		env,
		// dont waste rpc calls loading users for this made up wallet
		skipLoadUsers: true,
		enableMetricsEvents: true,
		txHandlerConfig: {
			blockhashCachingEnabled: Env.useCachedBlockhashFetcherInDriftClient,
		},
		opts: DRIFT_CLIENT_OPTS,
		delistedMarketSetting: DelistedMarketSetting.Unsubscribe,
	};

	return new DriftClient(driftClientConfig);
};
